import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function CtaSection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Soft%20elegant%20fashion%20product%20flatlay%20collection%20with%20neutral%20toned%20clothing%20accessories%20sneakers%20and%20bags%20arranged%20artistically%20on%20light%20surface%20minimalist%20European%20aesthetic%20cream%20background%20natural%20daylight%20editorial%20photography%20airy%20atmosphere&width=1800&height=800&seq=cta-bg-fashion-01&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/85 to-background-50/70"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-foreground-900 font-heading mb-4">
          {t('section_cta_title')}
        </h2>
        <p className="text-sm md:text-lg text-foreground-600 mb-8 max-w-xl mx-auto leading-relaxed">
          {t('section_cta_subtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-900/20"
          >
            <i className="ri-external-link-line"></i>
            {t('section_cta_btn')}
          </a>
          <Link
            to="/kakobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-500 font-semibold text-base border border-primary-200 hover:bg-primary-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line"></i>
            {t('btn_read_article')}
          </Link>
        </div>
      </div>
    </section>
  );
}